import { useState, useEffect } from "react";
import { toast } from "../utils/toast";

export default function CoverLetterModal({ onClose, onSubmit, initialCl, applications, preselectedAppId }) {
  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("");
  const [applicationId, setApplicationId] = useState(preselectedAppId ? String(preselectedAppId) : "");
  const [file, setFile] = useState(null);
  const [inputMode, setInputMode] = useState("pdf"); // "pdf" | "text"
  const [textContent, setTextContent] = useState("");

  useEffect(() => {
    if (initialCl) {
      setTitle(initialCl.title || "");
      setLanguage(initialCl.language || "");
      setApplicationId(initialCl.application_id || "");
      if (initialCl.content) {
        setInputMode("text");
        setTextContent(initialCl.content);
      }
    }
  }, [initialCl]);

  const handleSubmit = () => {
    if (!title.trim()) { toast("Title is required"); return; }
    if (!applicationId) { toast("Please select an application"); return; }
    if (!initialCl) {
      if (inputMode === "pdf" && !file) { toast("A PDF file is required"); return; }
      if (inputMode === "text" && !textContent.trim()) { toast("Cover letter text is required"); return; }
    }
    onSubmit({
      title,
      language,
      application_id: Number(applicationId),
      file: inputMode === "pdf" ? file : null,
      content: inputMode === "text" ? textContent.trim() : undefined,
    });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content doc-modal">
        <h2>{initialCl ? "Edit Cover Letter" : "New Cover Letter"}</h2>

        <div className="field">
          <label>Title</label>
          <input
            className="input-sm"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Google Cover Letter"
          />
        </div>

        {!preselectedAppId && (
          <div className="field">
            <label>Application</label>
            <select
              className="input-sm"
              value={applicationId}
              onChange={(e) => setApplicationId(e.target.value)}
            >
              <option value="">Select application...</option>
              {applications.map((a) => (
                <option key={a.id} value={a.id}>{a.title}</option>
              ))}
            </select>
          </div>
        )}

        <div className="field">
          <label>Language <span className="field-optional">(optional)</span></label>
          <input
            className="input-sm"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            placeholder="e.g. English, French"
          />
        </div>

        <div className="field">
          <div className="input-mode-toggle">
            <button
              type="button"
              className={`input-mode-btn${inputMode === "pdf" ? " active" : ""}`}
              onClick={() => setInputMode("pdf")}
            >Upload PDF</button>
            <button
              type="button"
              className={`input-mode-btn${inputMode === "text" ? " active" : ""}`}
              onClick={() => setInputMode("text")}
            >Paste Text</button>
          </div>
        </div>

        {inputMode === "pdf" ? (
          <div className="field">
            <label>{initialCl ? "Replace PDF" : "PDF"}</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => setFile(e.target.files[0])}
            />
            {initialCl && <span className="field-hint">Leave blank to keep existing file</span>}
          </div>
        ) : (
          <div className="field">
            <label>{initialCl ? "Replace Text" : "Cover Letter Text"}</label>
            <textarea
              className="input-sm"
              rows={8}
              value={textContent}
              onChange={(e) => setTextContent(e.target.value)}
              placeholder="Paste your cover letter here..."
            />
          </div>
        )}

        <div className="modal-buttons">
          <button onClick={handleSubmit}>{initialCl ? "Save Changes" : "Create"}</button>
          <button className="secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
